module.exports = __webpack_public_path__ + "static/media/grid2.e2583ccc.png";